module.exports = __webpack_public_path__ + "media/images/pic/for_who-49208f40d985388d5adfac7255ad1de8.svg";